<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
  >
    <template v-slot:activator="{ on }">
      <a
        href="javascript:;"
        v-on="on"
      >{{ text }}</a>
    </template>
    <v-card>
      <div
        class="pa-4 text-h6"
      >
        {{ $t('Outbox.FlowRecords') }}
      </div>
      <v-chip
        v-if="$chPtObjData('systemChinMessage', workItem)"
        class="ma-2"
        color="primary"
      >
        {{ $chPtObjData('systemChinMessage', workItem) }}
      </v-chip>
      <v-simple-table>
        <!--
        <thead>
          <tr>
            <th
              class="text-left"
              style="min-width: 100px;"
            >
              {{ $t('Outbox.PreviousHandler') }}
            </th>
            <th style="min-width: 120px;" />
            <th style="min-width: 120px;">
              {{ $t('Text.DownloadFile') }}
            </th>
            <th
              class="text-left"
              style="min-width: 120px;"
            >
              {{ $t('Outbox.Time') }}
            </th>
          </tr>
        </thead>
        -->
        <tbody>
          <tr
            v-for="(item,i) in workItem.workItemHistoryList"
            :key="i"
          >
            <!-- <td>{{ $chPtObjData('chinStaffName', item) }}</td> -->
            <td>{{ executor(item) }}</td>
            <td>{{ item.message }}</td>
            <td class="pl-0">
              <v-btn
                v-show="item.mainDocument && !$config.isApp"
                text
                @click="downloadOficioDoc(item)"
              >
                <v-icon>{{ mdiFileDownloadOutline }}</v-icon>{{ $t('Outbox.DownloadOriginalDoc') }}
              </v-btn>
              <v-btn
                v-show="item.attachmentList.length > 0 && !$config.isApp"
                text
                @click="downloadAttachmentsZip(item)"
              >
                <v-icon>{{ mdiFileDownloadOutline }}</v-icon>{{ $t('Outbox.DownloadPresentFile') }}
              </v-btn>
              <v-btn
                v-show="item.referenceDocumentList.length > 0 && !$config.isApp"
                text
                @click="downloadReferenceZip(item)"
              >
                <v-icon>{{ mdiFileDownloadOutline }}</v-icon>{{ $t('Outbox.DownloadRefFile') }}
              </v-btn>
            </td>
            <td>{{ cutSecond(item.completedTime) }}</td>
            <!--
            <td>
              <v-icon v-if="getIsUrgent(item)">
                mdi-flash
              </v-icon>
              <v-icon v-if="getIsDirectSendToEdocx(item)">
                mdi-truck-fast
              </v-icon>
            </td>
            -->
          </tr>
        </tbody>
      </v-simple-table>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="primary"
          @click="dialog = false"
        >
          {{ $t('PublicServant.Action.Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import workflowApi from '@/api/workflow/workflow'
import outboxApi from '@/api/outbox/outbox'
import { OUTBOX_FILE_TYPE, WORKFLOW_META_KEY } from '@/constant/constant'
import { downloadMethod } from '@/mixins/downloadMethod'
import datetimeUtil from '@/utils/datetimeUtil'
import { mdiFileDownloadOutline } from '@mdi/js'

export default {
  mixins: [downloadMethod],
  props: {
    text: {
      type: String,
      required: true
    },
    workItem: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      mdiFileDownloadOutline: mdiFileDownloadOutline,
      dialog: false
    }
  },
  methods: {
    getIsUrgent (item) {
      let value = this.getFormMetaValue(item, WORKFLOW_META_KEY.IS_URGENT)
      if (value) {
        return JSON.parse(value)
      } else {
        return null
      }
    },
    getIsDirectSendToEdocx (item) {
      let value = this.getFormMetaValue(item, WORKFLOW_META_KEY.IS_DIRECT_SEND_TO_EDOCX)
      if (value) {
        return JSON.parse(value)
      } else {
        return null
      }
    },
    getFormMetaValue (item, key) {
      let value = null
      if (item.formMetas) {
        item.formMetas.some(meta => {
          if (meta.formMetaKey === key) {
            value = meta.formMetaValue
            return true
          }
        })
      }
      return value
    },
    executor (item) {
      if (this.$chPtObjData('messageFromGroupChinName', item)) {
        return '(' + this.$chPtObjData('messageFromGroupChinName', item) + ') ' + this.$chPtObjData('chinStaffName', item)
      } else {
        return this.$chPtObjData('chinStaffName', item)
      }
    },
    cutSecond (dateStr) {
      if (dateStr) { return datetimeUtil.dateStrToYyyyMmDdHhMm(dateStr) }
    },
    // downloadAttachmentsZip (item) {
    //   this.downloadZip(OUTBOX_FILE_TYPE.ATTACHMENT, item.attachmentList[0].formAttributeId, item.attachmentList[0].workItemId)
    // },
    // downloadReferenceZip (item) {
    //   this.downloadZip(OUTBOX_FILE_TYPE.REFERENCE, item.attachmentList[0].formAttributeId, item.attachmentList[0].workItemId)
    // },
    downloadAttachmentsZip (historyItem) {
      this.downloadAttachments(this.workItem, OUTBOX_FILE_TYPE.ATTACHMENT, historyItem.attachmentList[0].workItemId)
    },
    downloadReferenceZip (historyItem) {
      this.downloadAttachments(this.workItem, OUTBOX_FILE_TYPE.REFERENCE, historyItem.attachmentList[0].workItemId)
    },
    // downloadZip (item, attachmentTypeId) {
    //   let formAttributeId = item.attachmentList[0].formAttributeId
    //   let workItemId = item.attachmentList[0].workItemId
    //   workflowApi.downloadAttachmentsZip(attachmentTypeId, formAttributeId, workItemId, resp => {
    //     if (resp.status === 201 || resp.status === 200) {
    //       const url = window.URL.createObjectURL(new Blob([resp.data]))
    //       const link = document.createElement('a')
    //       link.href = url
    //       let filename = (attachmentTypeId === OUTBOX_FILE_TYPE.ATTACHMENT) ? 'attachments.zip' : 'reference.zip'
    //       link.setAttribute('download', filename)
    //       link.click()
    //       window.URL.revokeObjectURL(url)
    //     }
    //   })
    // },
    downloadOficioDoc (item) {
      outboxApi.downloadFile(resp => {
        if (resp.status === 201 || resp.status === 200) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', item.mainDocument.fileName)
          link.click()
          window.URL.revokeObjectURL(url)
        }
      }, item.mainDocument.documentId)
    }
  }
}
</script>
